const state = () => ({
  createMigrationStep: 1,
  importedCsvValidation: [],
});

const getters = {
  createMigrationStepsNumber: () => 3,
  currentCreateMigrationStep: (state) => state.createMigrationStep,
  currentImportedCsvValidation: (state) => state.importedCsvValidation,
};

const actions = {};

const mutations = {
  setCreateMigrationStep(state, step) {
    if (step) {
      state.createMigrationStep = step;
    } else {
      state.createMigrationStep = 1;
    }
  },
  setImportedCsvValidation(state, data) {
    state.importedCsvValidation = data;
  },
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
